import React, { memo } from "react";
import { motion, AnimatePresence } from "framer-motion";

const MapLegend = memo(function MapLegend({ focusedCountry }) {
  return (
    <>
      {/* Legend */}
      <div className="absolute bottom-3 right-4 flex items-center gap-2 bg-[#1A1B2E]/80 backdrop-blur-sm border border-white/10 rounded-lg px-3 py-2">
        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
        <span className="text-xs text-white/50">Active users</span>
      </div>

      {/* Hint */}
      <AnimatePresence>
        {!focusedCountry && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute bottom-3 left-4"
          >
            <span className="text-[11px] text-white/25 italic">
              Hover over a cluster to explore
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
});

export default MapLegend;
